<div id="content">
  <div class="page-title">
    <h1>{{ page_title }}</h1>
    @if (permissions.validateDepartment(['direction', 'rrhh'])) {
      <button mat-flat-button color="accent" [routerLink]="['/employees', 'production', 'production-planification']">
        <mat-icon style="margin-right: 10px">settings</mat-icon>
        Planificación productiva
      </button>
    }
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>

      <mat-form-field appearance="outline" class="bisual-paginator-select">
        <mat-label>Estado</mat-label>
        <mat-select formControlName="ro_is_active">
          <mat-option [value]="">Todos</mat-option>
          <mat-option [value]="1">Activo</mat-option>
          <mat-option [value]="0">Finalizado</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input matInput type="text" formControlName="search" />
        <button matSuffix mat-icon-button aria-label="Clear">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Producto</th>
          <td mat-cell *matCellDef="let company_product">
            <div class="d-flex">
              <div class="company-product-logo" [ngStyle]="{ 'background-image': 'url(' + company_product.logo_url + ')' }"></div>
              <a [routerLink]="getCompanyProductDetailLink(company_product.id)">{{ company_product.title }}</a>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="phases">
          <th mat-header-cell *matHeaderCellDef>Fases</th>
          <td mat-cell *matCellDef="let company_product">
            {{ company_product.company_product_phases.length == 1 ? '1 fase' : company_product.company_product_phases.length + ' fases' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef>Cliente</th>
          <td mat-cell *matCellDef="let company_product">
            @if (company_product.company_id == null) {
              <span>Bisual</span>
            }
            @if (company_product.company_id != null) {
              <a [routerLink]="['/employees', 'direction', 'companies', company_product.company_id]">{{
                company_product.company.fact_name
              }}</a>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="product_manager">
          <th mat-header-cell *matHeaderCellDef>Product Manager</th>
          <td mat-cell *matCellDef="let company_product">
            {{ company_product.active_company_product_members | companyProductRoleMembersLabel: 'product-manager' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="product_designer">
          <th mat-header-cell *matHeaderCellDef>Product Designer</th>
          <td mat-cell *matCellDef="let company_product">
            {{ company_product.active_company_product_members | companyProductRoleMembersLabel: 'product-designer' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="tech_lead">
          <th mat-header-cell *matHeaderCellDef>Tech Lead</th>
          <td mat-cell *matCellDef="let company_product">
            {{ company_product.active_company_product_members | companyProductRoleMembersLabel: 'tech-lead' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="account_manager">
          <th mat-header-cell *matHeaderCellDef>Account Manager</th>
          <td mat-cell *matCellDef="let company_product">
            {{ company_product.account_manager_label }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let company_product; let i = index">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item [routerLink]="getCompanyProductDetailLink(company_product.id)">
                <mat-icon style="margin-right: 10px">login</mat-icon>
                Acceder
              </button>
              <button mat-menu-item (click)="shareScreen(company_product.id)">
                <mat-icon style="margin-right: 10px">screen_share</mat-icon>
                Modo reunión
              </button>
              @if (permissions.validateDepartment(['direction', 'rrhh'])) {
                <button mat-menu-item (click)="openCompanyProductSettings(company_product)">
                  <mat-icon style="margin-right: 10px">settings</mat-icon>
                  Configurar producto
                </button>
              }
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
